<script setup>
import { ref, onMounted } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Autoplay } from "swiper";

const isModalVisible = ref(false);

const openVideoModal = () => {
  isModalVisible.value = true;
};

const closeModal = () => {
  isModalVisible.value = false;
};

let selectedLanguage = ref("japanese");

const switchToJapanese = () => {
  if (selectedLanguage.value === "english") {
    selectedLanguage.value = "japanese";
  }
};
const switchToEnglish = () => {
  if (selectedLanguage.value === "japanese") {
    selectedLanguage.value = "english";
  }
};

const images = [
  {
    src: require("../../assets/images/work/rm3_top.jpeg"),
    alt: "",
  },
  {
    src: require("../../assets/images/work/rm3_top2.jpeg"),
    alt: "",
  },
  {
    src: require("../../assets/images/work/rm3_3.jpeg"),
    alt: "",
  },
];

// ｼｭﾝ
const shrinkTitle = ref(null);
const shrinkElement = ref(null);
onMounted(() => {
  window.addEventListener("scroll", shrinkTitleOnScroll);
  window.addEventListener("scroll", shrinkElementOnScroll);
});

const shrinkTitleOnScroll = () => {
  const element = shrinkTitle.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add("-show");
      window.removeEventListener("scroll", shrinkTitleOnScroll);
    }
  }
};
const shrinkElementOnScroll = () => {
  const element = shrinkElement.value;
  if (element) {
    const elementPosition = element.getBoundingClientRect().top;
    if (elementPosition - window.innerHeight <= -120) {
      element.classList.add("-show");
      window.removeEventListener("scroll", shrinkElementOnScroll);
    }
  }
};
</script>

<template>
  <div class="work" id="work">
    <div class="background-content">
      <p class="background-right shrink-title -right" ref="shrinkTitle">WORK</p>
    </div>

    <div class="work-content shrink-element" ref="shrinkElement">
      <div class="head">
        <div class="description">
          <div class="photos-slider">
            <Swiper
              :modules="[Pagination, Autoplay]"
              :loop="true"
              :pagination="{ clickable: true }"
              :autoplay="{ delay: 4000, disableOnInteraction: false }"
              :slides-per-view="1"
              :space-between="0"
              :breakpoints="{
                1080: { slidesPerView: 3, spaceBetween: 12 },
              }"
            >
              <SwiperSlide v-for="(image, index) in images" :key="index">
                <img :src="image.src" :alt="image.alt" @click="openVideoModal" />
              </SwiperSlide>
            </Swiper>
          </div>
          <div class="toggle-row">
            <div class="toggle">
              <button
                @click="switchToJapanese"
                :class="selectedLanguage === 'japanese' ? '-selected' : ''"
              >日本語</button>
              <button
                @click="switchToEnglish"
                :class="selectedLanguage === 'english' ? '-selected' : ''"
              >English</button>
            </div>
          </div>
          <transition name="lang-fade" mode="out-in">
          <div class="text -japanese" v-if="selectedLanguage === 'japanese'" key="ja">
            <p class="name-line">Ryu Muraki Three</p>
            <p>
              <span>村木龍</span
              >(クラリネット)、<span>市川空</span>(ピアノ)、<span>海老原颯</span>(ドラム)の
              3 人により 2021 年結成。
            </p>
            <p>
              スイングジャズ期に活躍した「ベニーグッドマン・トリオ」のスタイルを踏襲し、スイングナンバー、ジャズスタンダード、オリジナル曲を通じて、その魅力を広く伝えながら、自分たちの音楽を追求する。
            </p>
            <p>
              首都圏ライブハウスへの出演のほか、スイングジャズ期にアメリカで流行した「スイング・ダンス（リンディホップ/バルボア）」のイベントにてパーティバンドとして演奏するなど、幅広く精力的に演奏活動を行う。
            </p>
            <p>
              「けやき音楽祭JAZZ
              in FUCHU」(2022〜25年)出演。2023年11月、1stアルバム「Playin'
              The Hero」(Yokohama
              Reunion)を発売。同年12月、第41回浅草ジャズコンテスト・バンド部門において銀賞受賞。2026年3月、2ndアルバム「Ryu
              Muraki
              Three」(S.Activities)を発売。2026年4月、韓国(ソウル)で行われたAsia
              Balboa Exchangeにパーティバンドとして出演。
            </p>
          </div>
          <div class="text -english" v-else key="en">
            <p class="name-line">Ryu Muraki Three</p>
            <p>
              "Ryu Muraki Three" was formed in 2021 by Ryu Muraki (clarinet),
              Sora Ichikawa (piano), and So Ebihara (drums).
            </p>
            <p>
              They follow the style of the "Benny Goodman Trio" that was active
              during the swing jazz era, and pursue their own music through
              swing numbers, jazz standards, and original songs, while
              spreading their appeal widely.
            </p>
            <p>
              In addition to performing at live houses in the Tokyo
              metropolitan area, they have also been performing energetically
              in a wide range of events, including as a party band at "Swing
              Dance (Lindy Hop/Balboa)" events, which were popular in the U.S.
              during the swing jazz era.
            </p>
            <p>
              They performed at the "Keyaki Music Festival JAZZ in FUCHU"
              (2022-25). In November 2023, they released their 1st album
              "Playin' The Hero" (Yokohama Reunion), and in December of the
              same year, they won the Silver Award in the Band Division of the
              41st Asakusa Jazz Contest. In March 2026, they released their
              2nd album "Ryu Muraki Three" (S.Activities). In April 2026, they
              performed as a party band at the Asia Balboa Exchange held in
              Seoul, South Korea.
            </p>
          </div>
          </transition>
          <a
            class="ig-follow"
            href="https://www.instagram.com/ryumuraki3/"
            target="_blank"
            rel="noopener"
          >
            <font-awesome-icon :icon="['fab', 'instagram']" class="fontawesome" />
            <span>Instagram</span>
          </a>
        </div>
      </div>
    </div>

    <transition name="modal-fade">
      <div v-if="isModalVisible" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <h2>Ryu Muraki Three</h2>
          <div class="iframe-wrapper">
            <iframe
              src="https://www.youtube.com/embed/GFQ0FgSGMls"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen
            ></iframe>
          </div>
          <p>
            村木龍(クラリネット)、市川空(ピアノ)、海老原颯(ドラム)の3人により2021年結成。
          </p>
          <p>
            スイングジャズ期に活躍した「ベニーグッドマン・トリオ」のスタイルを踏襲し、スイングナンバー、ジャズスタンダード、オリジナル曲を通じて、その魅力を広く伝えながら、自分たちの音楽を追求する。
          </p>
        </div>
      </div>
    </transition>
  </div>
</template>

<style lang="scss" src="./style.scss" scoped></style>
